exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn[data-v-74841abd] {\n  margin-right: 16px;\n}\n.action-button[data-v-74841abd] {\n  display: inline-block;\n}\n", ""]);

// exports
